@for (fUnit of functionalUnits; track fUnit) {
  <sh-text
    class="unit-label"
    [id]="formatClassName(fUnit)"
    [class]="formatClassName(fUnit)"
    color="secondary"
    [ctsGantryGridHighlight]="formatClassName(fUnit)"
  >
    {{ fUnit }}
  </sh-text>
}
